import {unzipSync,strFromU8} from "fflate";

// Read only the first worksheet and shared strings, never macros or external links.
export function xlsxToCsv(buffer){
 const archive=unzipSync(new Uint8Array(buffer),{filter:f=>
  /^xl\/(worksheets\/sheet1\.xml|sharedStrings\.xml)$/.test(f.name)&&f.originalSize<=2_000_000
 });
 const sheet=archive["xl/worksheets/sheet1.xml"];
 if(!sheet)throw new Error("Não foi possível ler a primeira aba do Excel.");
 const parser=new DOMParser();
 const documentOf=bytes=>{
   const doc=parser.parseFromString(strFromU8(bytes),"application/xml");
   if(doc.getElementsByTagName("parsererror").length)throw new Error("Arquivo Excel inválido.");
   return doc;
 };
 const shared=archive["xl/sharedStrings.xml"]
  ? Array.from(documentOf(archive["xl/sharedStrings.xml"]).getElementsByTagName("si"),
     item=>Array.from(item.getElementsByTagName("t")).map(n=>n.textContent||"").join(""))
  : [];
 const document=documentOf(sheet);
 const rows=Array.from(document.getElementsByTagName("row")).slice(0,202).map(row=>{
  const cells=[];
  Array.from(row.getElementsByTagName("c")).forEach(cell=>{
   const ref=cell.getAttribute("r")||"A1";
   const letters=(ref.match(/^[A-Z]+/i)||["A"])[0].toUpperCase();
   let index=0;for(const char of letters)index=index*26+char.charCodeAt(0)-64;index--;
   if(index<0||index>50)return;
   const raw=cell.getElementsByTagName("v")[0]?.textContent||"";
   const type=cell.getAttribute("t");
   const value=type==="s"?shared[Number(raw)]||"":type==="inlineStr"?
     Array.from(cell.getElementsByTagName("t")).map(n=>n.textContent||"").join(""):raw;
   cells[index]=String(value||"");
  });
  return cells;
 });
 const quote=value=>'"'+String(value||"").replace(/"/g,'""')+'"';
 return rows.map(row=>row.map(quote).join(";")).join("\n");
}
